import React from 'react';
import icon from '../images/marqeting-responsable.png';
import icon2 from '../images/engagement-social.png';
import icon3 from '../images/portection-mineur.png';
import engagementpart1_1 from '../images/engagementpart1_1.jpg';
import engagementpart1_2 from '../images/engagementpart1_2.jpg';
import engagementpart1_3 from '../images/engagementpart1_3.jpg';
import engagementpart1_4 from '../images/engagementpart1_4.jpg';
import logo from '../images/logoBIVAC.png';
import logo1 from '../images/logoDGDA.png';
import logo2 from '../images/logoMinSan.png';
import logo3 from '../images/logoOCC.png';
import logo4 from '../images/logoOGEFREM.png';
import logo5 from '../images/logoSEGUCE.png';
import { Pagination, Autoplay, Scrollbar, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { useLang } from "./Provider/LanguageProvider";

function NosEngagements() {
  const { language } = useLang();

  return (
    <div id='nosengagements'>
      <div className='gap-engagements'></div>
      <section className='section1'>
        <div className='welcome'>
          <span className='pre-title'>{language === 'fr' ? 'NOUS PLAÇONS' : 'WE PLACE'}</span>
          <h1>{language === 'fr' ? "LA RESPONSABILITÉ AU COEUR DE NOTRE ACTIVITÉ" : 'RESPONSIBILITY AT THE HEART OF OUR BUSINESS'}</h1>
        </div>
      </section>
      <section className='section2'>
        <div className='container'>
          {language === 'fr' ?
            <p>
              Nous nous engageons à gérer nos opérations de manière éthique, transparente et respectueuse des réglementations
              en vigueur.
            </p> :
            <p>
              We are committed to managing our operations ethically, transparently, and in compliance with applicable regulations.
            </p>
          }
          <div className='mid-container'>
            <div className='img-cont' data-aos="fade-right">
              <Swiper
                className='pic-cont'
                modules={[Pagination, Scrollbar, FreeMode, Autoplay]}
                slidesPerView='1'
                scrollbar={{
                  draggable: true,
                }}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: false
                }}
              >
                <SwiperSlide className='pic'>
                  <img src={engagementpart1_1} alt='engagement pic' />
                </SwiperSlide>
                <SwiperSlide className='pic'>
                  <img src={engagementpart1_2} alt='engagement pic' />
                </SwiperSlide>
                <SwiperSlide className='pic'>
                  <img src={engagementpart1_3} alt='engagement pic' />
                </SwiperSlide>
                <SwiperSlide className='pic'>
                  <img src={engagementpart1_4} alt='engagement pic' />
                </SwiperSlide>
              </Swiper>
            </div>
            <div className='text-cont' data-aos="fade-left">
              <ul>
                <li>
                  <img src={icon} alt='shield' />
                  {language === 'fr' ?
                    <div className='text-wrapper'>
                      <h3>Marketing responsable</h3>
                      <span>Nos communications visent uniquement un public adulte, afin de
                        promouvoir une consommation éclairée et conforme aux lois en
                        vigueur.</span>
                    </div> :
                    <div className='text-wrapper'>
                      <h3>Responsible Marketing</h3>
                      <span>
                        Our communications target only an adult audience to promote informed consumption
                        in compliance with applicable laws.
                      </span>
                    </div>
                  }
                </li>
                <li>
                  <img src={icon3} alt='thumbs up' />
                  {language === 'fr' ?
                    <div className='text-wrapper'>
                      <h3>Protection des mineurs</h3>
                      <span>Nous veillons strictement à ce que nos produits ne soient
                        accessibles qu’aux consommateurs adultes, en collaborant avec
                        toutes les parties prenantes pour prévenir toute infraction.</span>
                    </div> :
                    <div className='text-wrapper'>
                      <h3>Protection of Minors</h3>
                      <span>
                        We strictly ensure that our products are accessible only to adult consumers,
                        collaborating with all stakeholders to prevent any violations.
                      </span>
                    </div>

                  }
                </li>
                <li>
                  <img src={icon2} alt='social' />
                  {language === 'fr' ?
                    <div className='text-wrapper'>
                      <h3>Engagement social</h3>
                      <span>Shenimed s’associe aux initiatives visant à lutter contre le
                        commerce illicite et soutenir les communautés locales, tout en
                        encourageant un cadre réglementaire équitable et fondé sur des
                        preuves.</span>
                    </div> :
                    <div className='text-wrapper'>
                      <h3>Social Commitment</h3>
                      <span>
                        Shenimed partners with initiatives aimed at combating illegal trade and supporting local communities,
                        while promoting a fair and evidence-based regulatory framework.
                      </span>
                    </div>
                  }
                </li>
              </ul>
              <div class="organisation-wrapper">
                <div class="organisation">
                  <img src={logo} height="55px" width="auto" alt="logo" />
                </div>
                <div class="organisation">
                  <img src={logo1} height="55px" width="auto" alt="logo" />
                </div>
                <div class="organisation">
                  <img src={logo2} height="55px" width="auto" alt="logo" />
                </div>
                <div class="organisation">
                  <img src={logo3} height="55px" width="auto" alt="logo" />
                </div>
                <div class="organisation">
                  <img src={logo4} height="55px" width="auto" alt="logo" />
                </div>
                <div class="organisation">
                  <img src={logo5} height="55px" width="auto" alt="logo" />
                </div>
              </div>
            </div>
          </div>
          {language === 'fr' ?
            <p>
              À travers ces actions, nous affirmons notre rôle d’acteur responsable, dédié à un avenir plus durable et respectueux
              des attentes de la société.
            </p> :
            <p>
              Through these actions, we affirm our role as a responsible actor, dedicated to a more sustainable future
              that respects the expectations of society.
            </p>
          }
        </div>
      </section>
    </div>
  )
}

export default NosEngagements